import React from 'react';
import qs from "qs";
import GlobalContext from '../context/GlobalContext';

const login = async (data) => {

    const resp = await fetch(`/api/auth/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accept': '*/*'
        },
        body: qs.stringify(data)
    });
    const token = await resp.json();

    return token;
}

const saveToken = (token) => {
    localStorage.setItem('jwt', token);
}

const getToken = () => {
    const saved = localStorage.getItem('jwt');
    const token = saved;
    return token || '';
}

const GetTokenContext = () => {
    const {token} = React.useContext(GlobalContext);
    return token;
}

const getStudentInfo = async (message) => {

    const body = {
        message: message,
    }

    const resp = await fetch(`/api/auth/student`, {
        method: 'POST',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(body)
    });

    if(resp.status != 200 && resp.status != 202){
        throw new Error;
    }

    return await resp.json();
}

const LogOut = () => {
    // const {setToken} = React.useContext(GlobalContext);
    localStorage.removeItem('jwt');
    // setToken('');
    window.location.reload();
}

export {
    login,
    saveToken,
    getToken,
    GetTokenContext,
    getStudentInfo,
    LogOut
}
